// features/source-monitoring/api.ts
import axios from "@/hooks/axios/axios";

export type sourcePublicationsParams = {
  page?: number;
  limit?: number;
  search?: string;
};

export async function getPublicationsRaw(
  endpoint: string,
  params: sourcePublicationsParams = {},
) {
  const { data } = await axios.get(`publications/${endpoint}`, { params });
  return data;
}
